const API_LINK = 'index.php?route=design/gallery/apiGetImage'

export function getHistoryBanner(bannerId) {
  return fetch(API_LINK + '&id=' + bannerId)
    .then(response => {
      if (response.ok) return response.json()
    })
    .then(json => {
      return json.map(item => ({
        src: item.image,
        opts: {
          caption: item.title,
          thumb: item.thumb
        }
      }))
    })
}
